import {useEffect, useState} from 'react'
import Loader from '../../custom/loader/Loader'
import {useTranslation} from 'react-i18next'
import {useAppDispatch} from '../../../redux/hooks'
import {LecturerNews} from '../../../redux/Slice/lecturerSlice'

const LecturerDashboard = () => {
  const [loader, setLoader] = useState(true)
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const [news, setNews] = useState<any[]>([])

  useEffect(() => {
    dispatch(LecturerNews()).then((res: any) => {
      if (res.meta.requestStatus === 'fulfilled') {
        setNews(res.payload)
        setLoader(false)
      }
    })
  }, [])

  // Function to format date
  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }
    return new Date(dateString).toLocaleDateString('en-GB', options).replace(',', '')
  }

  if (loader) {
    return <Loader />
  }

  return (
    <>
      <div className='container-fluid p-0'>
        <div className='card mb-3 p-0'>
          <div className='card-header border-0 bg-white py-4 rounded-top-4'>
            <h3 className='fw-bold text-primary m-0'>{t('LABEL.NEWS_AND_ANNOUNCEMENT')}</h3>
          </div>
        </div>
      </div>

      {news.length > 0 &&
        news.map((item: any) => (
          <div key={item.id} className='card mb-3 shadow-sm rounded-4'>
            <div
              className='card-header bg-primary d-flex flex-column justify-content-center'
              style={{minHeight: '40px', cursor: 'pointer'}}
              data-bs-toggle='collapse'
              data-bs-target={`#news-${item.id}`}
              aria-expanded='false'
              aria-controls={`news-${item.id}`}
            >
              <h5 className='card-title fw-bold text-white mb-0'>{item.title}</h5>
              <small className='text-light mx-3 fw-bold mb-1'>
                <i className='fas fa-calendar-alt mx-1'></i>
                {formatDate(item.created_at)}
              </small>
            </div>

            <div id={`news-${item.id}`} className='collapse'>
              <div className='card-body'>
                <p
                  dangerouslySetInnerHTML={{
                    __html: item.content,
                  }}
                ></p>
              </div>
            </div>
          </div>
        ))}
    </>
  )
}

export default LecturerDashboard
